import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ReactModal from 'react-modal';
import { ModalStyles } from './ModalStyles';
import { ModalWindow } from './ModalWindow';
export const Modal = _ref => {
  let {
    bodyOpenClassName,
    className,
    closeTimeoutMS,
    children,
    overlayClassName,
    animationType,
    ...rest
  } = _ref;
  const modifier = animationType !== null && animationType !== void 0 ? animationType : 'top-slide-in';
  return /*#__PURE__*/React.createElement(ReactModal, _extends({
    bodyOpenClassName: bodyOpenClassName !== null && bodyOpenClassName !== void 0 ? bodyOpenClassName : 'TombacModal__body--open',
    className: className !== null && className !== void 0 ? className : {
      base: `TombacModal TombacModal--${modifier}`,
      afterOpen: `TombacModal--after-open-${modifier}`,
      beforeClose: `TombacModal--before-close-${modifier}`
    },
    closeTimeoutMS: closeTimeoutMS !== null && closeTimeoutMS !== void 0 ? closeTimeoutMS : 1000,
    overlayClassName: overlayClassName !== null && overlayClassName !== void 0 ? overlayClassName : {
      base: `TombacModal__overlay TombacModal__overlay--${modifier}`,
      afterOpen: `TombacModal__overlay--after-open-${modifier}`,
      beforeClose: `TombacModal__overlay--before-close-${modifier}`
    }
  }, rest), /*#__PURE__*/React.createElement(ModalStyles, null), /*#__PURE__*/React.createElement(ModalWindow, null, children));
};
//# sourceMappingURL=Modal.js.map